var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import styles from './styles.module.scss';
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    default_1.prototype.render = function () {
        return React.createElement("div", { className: styles.overlay, onClick: this.props.onClick });
    };
    default_1.prototype.componentDidMount = function () {
        document.body.classList.add(styles.positionFixed);
    };
    default_1.prototype.componentWillUnmount = function () {
        document.body.classList.remove(styles.positionFixed);
    };
    return default_1;
}(Component));
export default default_1;
